import { combineReducers } from 'redux';
import appResources from './resources.reducer';
import appResource from './resource.reducer';

const resourcesReducer = combineReducers({
	appResources,
	appResource
});

export default resourcesReducer;
